module.exports = __webpack_public_path__ + "static/media/corruption_token.a493c69b.png";